import { Controller } from 'stimulus';
import loadSlick from '../helpers/loadSlick';

class Slider extends Controller {
  connect() {
    loadSlick().then(() => {
      this.$element = $(this.element);
      const { arrowsAtBottom } = this.sliderOptionsFromElement();

      if (typeof arrowsAtBottom !== 'undefined' && arrowsAtBottom) {
        this.$element.on('init', () => {
          this.calculateArrowPosition($(this.element).find('.slick-current'));
        });

        this.$element.on('setPosition', () => {
          this.calculateArrowPosition($(this.element).find('.slick-current'));
        });

        this.$element.on('beforeChange', (_event, slick, currentSlide) => {
          this.calculateArrowPosition($(slick.$slides[currentSlide]));
        });
      }

      this.$element.slick({
        prevArrow: Slider.getSliderButton('Vorige', 'slider__arrow slick-prev btn--reset', 'chevron-left'),
        nextArrow: Slider.getSliderButton('Volgende', 'slider__arrow slick-next btn--reset', 'chevron-right'),
        ...this.sliderOptionsFromElement(),
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  calculateArrowPosition(slide) {
    const $currentSlideElement = slide;
    const $slideImage = $currentSlideElement.find('[data-target="slideImage"]');
    const $nextArrow = $(this.element).find('.slick-prev');
    const $prevArrow = $(this.element).find('.slick-next');
    const top = $slideImage.outerHeight() - $nextArrow.height() - 15;

    $nextArrow.css('top', top);
    $prevArrow.css('top', top);
  }

  sliderOptionsFromElement() {
    const options = this.$element.data();
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = new RegExp('^slider', 'g');

      if (!regex.test(option)) {
        return;
      }

      // Transform the key from 'sliderArrows' to 'Arrows'
      let transformedOption = option.replace('slider', '');

      // Lowercase the first character ('Arrows' => 'arrows')
      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      config[transformedOption] = options[option];
    });

    return config;
  }

  static getSliderButton(text, className, icon) {
    return `
      <button type="button" class="${className}">
        <span class="sr-only">${text}</span>
        ${Slider.getButtonIcon(icon)}
      </button>
    `;
  }

  static getButtonIcon(name) {
    return `<svg class="icon icon-${name}" aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
  }
}

Slider.targets = [
  //
];

export default Slider;
